import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "_fl"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("a", _mergeProps({ href: "" }, _ctx.$attrs, {
    class: $options.linkClass,
    disabled: !$props.enabled,
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onClick && $options.onClick(...args)), ["prevent"]))
  }), [
    ($props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_base_icon, { name: $props.icon }, null, 8 /* PROPS */, ["name"]),
          _cache[1] || (_cache[1] = _createTextVNode(" ", -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ], 16 /* FULL_PROPS */, _hoisted_1))
}